type CustomError = {
  code: number;
  message: string;
  count?: number;
  expectedCount?: number;
  class?: any;
};

export const getLocalisedErrorMessage = (error: CustomError) => {
  console.log(error);

  if (error.code === 1) {
    return "Es sind keine Studenten zu verteilen";
  }

  if (error.code === 2) {
    return "Es gibt keine Klassen im Projekt";
  }

  if (error.code === 3) {
    return `Es gibt nicht genug Student, um mindestens alle Klassen zu erfüllen (${error.count} vs ${error.expectedCount})`;
  }

  if (error.code === 4) {
    return `Es gibt zu viele Schüler, die Klassen enthalten können (${error.count} vs ${error.expectedCount})`;
  }

  if (error.code === 5) {
    return "Einige Schüler konnten nicht verteilt werden";
  }

  if (error.code === 6) {
    return "Manche Schüler haben keine Adresse";
  }

  if (error.code === 7) {
    return `Minimum der Klassengrösse unterschritten ${error?.class.name}`;
  }

  return error.message;
};
